/** The store and account website. */
export const SITE_URL: string = import.meta.env.VITE_SITE_URL || 'https://superelectric.ink'
